import GlossaryLettersList from "../../lists/glossaryScreen/GlossaryLettersList";
import GlossaryResearchVoid from "../../voids/glossaryScreen/GlossaryResearchVoid";
import GlossaryTerms from "./GlossaryTerms";
import {isNullOrUndefined} from "../../../services/Validator";
import SystemAppContentError from "../../errors/SystemAppContentError";
import SystemAppContentLoader from "../../loaders/SystemAppContentLoader";
import GlossarySearchBar from "../../bars/glossaryScreen/GlossarySearchBar";
import GlossaryTermsHeader from "../../headers/glossaryScreen/GlossaryTermsHeader";

export default function GlossaryCoreContent({ error,
                                              getTerms,
                                              isLoading,
                                              filteredTerms,
                                              terms,
                                              search,
                                              handleSearchChange,
                                              isSearching,
                                              setIsStrictMode,
                                              scrollToLetter,
                                              debouncedSearch,
                                              refs,
                                              highlight }) {
    // Used in GlossaryContent to handle display of
    // core content like search bar and terms list

    // BUILD
    if (!isNullOrUndefined(error))
        return <SystemAppContentError error={error}
                                      isLoading={isLoading}
                                      retryCallback={() => getTerms()} />
    if (isLoading)
        return <SystemAppContentLoader />
    const displayedTerms = filteredTerms ?? terms;
    return (
        <div className={"mt-[24px] grow w-full min-h-0 flex flex-col justify-start items-center"}>
            <div className={"w-full flex flex-wrap justify-between items-center gap-x-[8px] gap-y-[12px] px-[16px]"}>
                <GlossarySearchBar search={search}
                                   isSearching={isSearching}
                                   setIsStrictMode={setIsStrictMode}
                                   handleSearchChange={handleSearchChange} />
                <GlossaryLettersList terms={displayedTerms}
                                     scrollToLetter={scrollToLetter} />
            </div>
            <GlossaryTermsHeader />
            {debouncedSearch.trim() !== "" && Object.keys(displayedTerms || {}).length === 0 && (
                <GlossaryResearchVoid clearResearch={() => handleSearchChange('')} />
            )}
            <GlossaryTerms refs={refs}
                           terms={displayedTerms}
                           highlight={highlight}
                           search={debouncedSearch} />
        </div>
    );
}